<template>
  <div class="logistics-container">
    <div class="com-detail-hd">
      <detail-header></detail-header>
    </div>
    <div class="logisticsOrder-container">
      <div class="title">
        <p>项目名称</p>
        <p>{{ForumName}}</p>
      </div>
      <div>
        <p>
          <span>合同号</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="text"
               placeholder="请填写合同号"
               v-model="Info.ContractNumber" />
      </div>
      <div class="addProduct">
        <div class="addBtn"
             @click="addProduct">
          <span>继续添加产品+</span>
        </div>
        <ul v-for="(item,index) of Products"
            :key="item.ProliaoNum">
          <li>
            <p>
              <span>产品料号</span>
              <span class="point">&nbsp;*</span>
            </p>
            <input class="input-text"
                   type="text"
                   placeholder="输入产品料号"
                   v-model="item.ProLiaoNum" />
            <div class="del"
                 v-if="index>0"
                 @click="delProduct(index)">
              <span>删除</span>
            </div>
          </li>
          <li>
            <p>
              <span>产品名称</span>
              <span class="point">&nbsp;*</span>
            </p>
            <input class="input-text"
                   type="text"
                   placeholder="输入产品名称"
                   v-model="item.ProName" />
          </li>
          <li>
            <p>
              <span>数量</span>
              <span class="point">&nbsp;*</span>
            </p>
            <input class="input-text"
                   type="number"
                   placeholder="输入产品数量"
                   v-model="item.Number" />
          </li>
          <li>
            <p>
              <span>单位</span>
              <span class="point">&nbsp;*</span>
            </p>
            <input class="input-text"
                   type="text"
                   placeholder="输入产品单位"
                   v-model="item.NameEntity" />
          </li>
        </ul>
      </div>

      <div>
        <p>
          <span>需要日期</span>
          <span class="point">&nbsp;*</span>
        </p>
        <el-date-picker v-model="Info.RequiredDate"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"></el-date-picker>
      </div>
      <div>
        <p>
          <span>收货地址</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="text"
               placeholder="请填写收货地址"
               v-model="Info.ReceivingAddress" />
      </div>
      <div>
        <p>
          <span>收货人</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="text"
               placeholder="请填写收货人"
               v-model="Info.Consignee" />
      </div>
      <div>
        <p>
          <span>销售产值</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="number"
               placeholder="请填写销售产值"
               v-model="Info.SalesAmount" />
      </div>
      <div>
        <p>
          <span>回款金额</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="number"
               placeholder="请填写回款金额"
               v-model="Info.PaybackAmount" />
      </div>
      <div>
        <p>
          <span>回款比例</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="text"
               readonly
               :value="sum" />
      </div>
      <div>
        <p>
          <span>未达到合同回款比例</span>
          <span class="point">&nbsp;*</span>
        </p>
        <el-radio v-model="Info.OnetimesOffPayback"
                  label="true">是</el-radio>
        <el-radio v-model="Info.OnetimesOffPayback"
                  label="false">否</el-radio>
      </div>
      <div>
        <p>
          <span>两次以上不满足回款条件下单</span>
          <span class="point">&nbsp;*</span>
        </p>
        <el-radio v-model="Info.TwotimesOffPayback"
                  label="true">是</el-radio>
        <el-radio v-model="Info.TwotimesOffPayback"
                  label="false">否</el-radio>
      </div>
      <div>
        <p>
          <span>编辑人员</span>
          <span class="point">&nbsp;*</span>
        </p>
        <p class="edit"
           @click="ckEdit"
           :class="{'comp':isComp}">{{memberTextList.length>0?memberTextList.join(';'):'查看并编辑订单参与人员'}}</p>
      </div>
      <div>
        <p>
          <span>回款说明</span>
          <span class="point">&nbsp;*</span>
        </p>
        <input class="input-text"
               type="text"
               placeholder="请填写回款说明"
               v-model="Info.PaybackRemark" />
      </div>
      <div>
        <p>
          <span>备注</span>
        </p>
        <input class="input-text"
               type="text"
               placeholder="请填写备注内容"
               v-model="Info.Remarks" />
      </div>
      <div class="picUpload">
        <p class="picText">相关附件</p>
        <d-upload @getPicArr="getPicArr($event)"
                  :src="src"
                  height="220px"
                  width="200px"></d-upload>
      </div>
      <div class="btn">
        <p class="back"
           @click="back">返回</p>
        <p class="confirm"
           @click="confirm">确定</p>
      </div>
    </div>

    <div class="shadow-fixed"
         :class="{'show':isShow}">
      <div class="mask"></div>
      <div class="usersInfo-box">
        <div class="usersInfo-small-close"
             @click="isShow = !isShow"></div>
        <div class="usersInfo-scroll-box">
          <div class="usersInfo-inner">
            <div class="title">
              <div class="select-content"
                   @click="selectAll">
                <div class="select"
                     :class="{'active':allActive}"></div>
                <p>全选</p>
              </div>
              <div class="btn"
                   @click="complete">
                <span>完成</span>
              </div>
            </div>
            <div class="member-list">
              <ul class="list"
                  v-for="(val,key) in memberObj"
                  :key="key">
                <li class="head">
                  <div>
                    <span>{{val[0].Type}}</span>
                    <span v-if="val[0].TypeId == 1 || val[0].TypeId == 2 || val[0].TypeId == 9|| val[0].TypeId == 101|| val[0].TypeId == 102|| val[0].TypeId == 103">（必选）</span>
                  </div>
                </li>
                <li v-for="(item,index) of val"
                    :key="index"
                    class="main"
                    @click="toggle(val[index])">
                  <div class="content">
                    <div class="select"
                         :class="{'active':val[index].isActive}"></div>
                    <div class="headimg"
                         :style="{backgroundImage:`url(${item.HeadImg})`}"></div>
                    <p>{{item.NickName}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../html/pages/originality/logisticsOrder/logisticsOrder.scss"

import detailHeader from '../visaflow/components/detailHeader'
import dUpload from '../visaflow/components/d-upload'

import { GetCollaboretiveUsersInfo, AddCollaborativeOrder } from '../../../../api/index'

export default {
  data () {
    return {
      picArr: [],
      src: require('../../../../html/pages/originality/logisticsOrder/images/upload.png'),
      Info: {
        ContractNumber: '',//合同
        RequiredDate: '',//需要日期
        ReceivingAddress: '',//收货地址
        Consignee: '',//收货人信息
        Remarks: '',//备注信息
        SalesAmount: '',//销售产值
        PaybackAmount: '',//回款金额
        PaybackPercent: '',//回款比例
        OnetimesOffPayback: 'true',//未达到合同回款比例
        TwotimesOffPayback: 'true',//两次以上不满足回款条件下单
      },
      Products: [
        {
          ProName: '',
          ProLiaoNum: '',
          Number: '',
          NameEntity: ''
        }
      ],
      memberObj: {
        managerList: [{//项目经理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        fuzerenList: [{//项目负责
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        designerList: [{//项目设计
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zhianList: [{//项目质安
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        supporterList: [{ //业务支援
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        partyAList: [{//甲方
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        supervisorList: [{//监理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        xieliList: [{//协理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zxList: [{//中心领导
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        fgList: [{//分管领导
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zjlList: [{//总经理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        costList: [{//成本管理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }]
      },
      allActive: false,
      memberTextList: [],
      UserIds: [],//选择用户
      isShow: false,
      isComp: false,
      ForumId: '',
      ForumName: '',
      rules: {
        Info: {
          type: "object", required: true,
          fields: {
            ContractNumber: { required: true, message: '请填写合同号!' },
            RequiredDate: { required: true, message: '请填写需要日期!' },
            ReceivingAddress: { required: true, message: '请填写收货地址!' },
            Consignee: { required: true, message: '请填写收货人!' },
            PaybackRemark: { required: true, message: '请填写回款说明!' },
            SalesAmount: { required: true, message: '请填写销售产值!' },
            PaybackAmount: { required: true, message: '请填写回款金额!' },
          }
        },
        Products: {
          type: 'array', required: true,
          fields: [
            {
              type: "object", required: true,
              fields: {
                ProLiaoNum: { required: true, message: '请输入产品料号!' },
                ProName: { required: true, message: '请输入产品名称!' },
                Number: [
                  { required: true, message: '请输入数量!' },
                  { pattern: /^(\d+|\d+\.\d{1,2})$/, message: '数量必须是数字（保留2位小数）!' }
                ],
                NameEntity: { required: true, message: '请输入产品单位' }
              }
            },
          ]
        },
        memberTextList: {
          required: true, message: '请选择订单参与人员!'
        },
        // picArr: {
        //   required: true, message: '请上传附件!'
        // }
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    next();
    this.init();
  },
  computed: {
    sum () {
      return Number(this.Info.PaybackAmount / this.Info.SalesAmount * 100) + '%';
    },
  },
  methods: {
    getPicArr (data) {
      this.picArr = data;
    },
    addProduct () {
      this.Products.push(
        {
          ProName: '',
          ProLiaoNum: '',
          Number: ''
        }
      )
      this.rules.Products.fields.push(
        {
          type: "object", required: true,
          fields: {
            ProLiaoNum: { required: true, message: '请输入产品料号!' },
            ProName: { required: true, message: '请输入产品名称!' },
            Number: [
              { required: true, message: '请输入数量!' },
              { pattern: /^(0.\d{1,2}|\d+|[1-9]+.\d{1,2})$/, message: '数量必须是整数或2位小数!' }
            ],
            NameEntity: { required: true, message: '请输入产品单位' }
          }
        }
      )
    },
    delProduct (index) {
      this.Products.splice(index, 1);
      this.rules.Products.fields.splice(index, 1);
    },
    selectAll () {
      if (this.allActive) {
        for (let key in this.memberObj) {
          for (let i = 0; i < this.memberObj[key].length; i++) {
            this.memberObj[key][i].isActive = false;
          }
        }
      } else {
        for (let key in this.memberObj) {
          for (let i = 0; i < this.memberObj[key].length; i++) {
            this.memberObj[key][i].isActive = true;
          }
        }
      }
      this.allActive = !this.allActive;
    },
    toggle (obj) {
      obj.isActive = !obj.isActive;
      let count = 0;
      let activeCount = 0;
      for (let key in this.memberObj) {
        count++;
        activeCount++;
        for (let i = 0; i < this.memberObj[key].length; i++) {
          count++;
          if (this.memberObj[key][i].isActive) {
            activeCount++;
          }
        }
      }
      if (count == activeCount) {
        this.allActive = true;
      } else {
        this.allActive = false;
      }
    },
    complete () {
      this.memberTextList = [];
      this.UserIds = [];
      // console.log(this.memberObj);
      let managerCount = 0;
      let fuzeCount = 0;
      let xieliCount = 0;
      let zxCount = 0;
      let fgCount = 0;
      let zjlCount = 0;

      //判断项目经理是否勾选
      for (let x = 0; x < this.memberObj.managerList.length; x++) {
        if (!this.memberObj.managerList[x].isActive) {
          managerCount++
        } else break
      }
      if (managerCount == this.memberObj.managerList.length) {
        return this.$layer.alert('请选择项目经理!')
      }

      //判断项目负责是否勾选
      for (let y = 0; y < this.memberObj.fuzerenList.length; y++) {
        if (!this.memberObj.fuzerenList[y].isActive) {
          fuzeCount++
        } else break
      }
      if (fuzeCount == this.memberObj.fuzerenList.length) {
        return this.$layer.alert('请选择项目负责!')
      }

      //判断协理是否勾选
      for (let z = 0; z < this.memberObj.xieliList.length; z++) {
        if (!this.memberObj.xieliList[z].isActive) {
          xieliCount++
        } else break
      }
      if (xieliCount == this.memberObj.xieliList.length) {
        return this.$layer.alert('请选择协理!')
      }

      //判断中心领导是否勾选
      for (let z = 0; z < this.memberObj.zxList.length; z++) {
        if (!this.memberObj.zxList[z].isActive) {
          zxCount++
        } else break
      }
      if (zxCount == this.memberObj.zxList.length) {
        return this.$layer.alert('请选择中心领导!')
      }
      console.log(this.Info.OnetimesOffPayback, this.Info.TwotimesOffPayback)
      if (this.Info.OnetimesOffPayback && !this.Info.TwotimesOffPayback) {
        //判断分管领导是否勾选
        for (let z = 0; z < this.memberObj.fgList.length; z++) {
          if (!this.memberObj.fgList[z].isActive) {
            fgCount++
          } else break
        }
        if (fgCount == this.memberObj.fgList.length) {
          return this.$layer.alert('请选择分管领导!')
        }
      }

      if (!this.Info.OnetimesOffPayback && !this.Info.TwotimesOffPayback) {
        //判断总经理是否勾选
        for (let z = 0; z < this.memberObj.zjlList.length; z++) {
          if (!this.memberObj.zjlList[z].isActive) {
            zjlCount++
          } else break
        }
        if (zjlCount == this.memberObj.zjlList.length) {
          return this.$layer.alert('请选择总经理!')
        }
      }



      for (let key in this.memberObj) {
        for (let i = 0; i < this.memberObj[key].length; i++) {
          if (this.memberObj[key][i].isActive) {
            this.memberTextList.push(this.memberObj[key][i].NickName);
            if (this.memberObj[key][i].TypeId == 2) //项目负责
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 1
              })
            else if (this.memberObj[key][i].TypeId == 9) //协理
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 2
              })
            else if (this.memberObj[key][i].TypeId == 101) //中心领导
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 4
              })
            else if (this.memberObj[key][i].TypeId == 102) //分管领导
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 5
              })
            else if (this.memberObj[key][i].TypeId == 103) //总经理
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 6
              })
            else //其他的都归类为其他人员
              this.UserIds.push({
                UserId: this.memberObj[key][i].UserId,
                Type: 3
              })
          }
        }
      }
      this.isShow = false;
      if (this.memberTextList.length > 0) {
        this.isComp = true;
      } else {
        this.isComp = false;
      }
      // console.log(this.UserIds)
    },
    async confirm () {
      let validator = new this.$validator(this.rules);
      let model = {
        Info: this.Info,
        Products: this.Products,
        memberTextList: this.memberTextList.join(),
        picArr: this.picArr.join(),
      }
      validator.validate(model, async (errors, fields) => {
        if (!errors) {
          //提交
          this.Info.PaybackPercent = Number(this.Info.PaybackAmount / this.Info.SalesAmount)
          console.log({
            Info: this.Info,
            Images: this.picArr.join(),
            UserIds: this.UserIds,
            ForumId: this.ForumId,
            ForumName: this.ForumName,
            Products: this.Products
          })
          let res = await AddCollaborativeOrder({
            Info: this.Info,
            Images: this.picArr.join(),
            UserIds: this.UserIds,
            ForumId: this.ForumId,
            ForumName: this.ForumName,
            Products: this.Products
          })
          // console.log(res);
          if (res.Type == "Success") {
            this.$layer.alert(res.Content, (layerid) => {
              this.$layer.close(layerid);
              this.$router.push(`/originality/logisticsIndex/${this.$route.params.id}/1/1`)
            })
          } else {
            this.$layer.alert(res.Content);
          }
        } else {
          this.$layer.alert(errors[0].message);
        }
      });
    },
    ckEdit () {
      this.isShow = true
      this.init()
    },
    async init () {
      let res = await GetCollaboretiveUsersInfo({
        forumId: this.$route.params.id
      })
      this.memberObj = {
        managerList: [{//项目经理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        fuzerenList: [{//项目负责
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        designerList: [{//项目设计
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zhianList: [{//项目质安
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        supporterList: [{ //业务支援
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        partyAList: [{//甲方
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        supervisorList: [{//监理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        xieliList: [{//协理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zxList: [{//中心领导
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        fgList: [{//分管领导
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        zjlList: [{//总经理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }],
        costList: [{//成本管理
          HeadImg: '',
          NickName: '',
          Type: '',
          TypeId: '',
          UserId: ''
        }]
      }
      // console.log(res);
      if (res.Type == "Success") {
        this.ForumId = res.Data.ForumId;
        this.ForumName = res.Data.ForumName;
        if (this.Info.OnetimesOffPayback == 'true' && this.Info.TwotimesOffPayback == 'true' || this.Info.OnetimesOffPayback == 'false' && this.Info.TwotimesOffPayback == 'true') {
          var typeMap = {
            1: 'managerList',
            2: 'fuzerenList',
            3: 'designerList',
            4: 'zhianList',
            5: 'supporterList',
            6: 'partyAList',
            7: 'supervisorList',
            9: 'xieliList',
            101: 'zxList',
            102: 'fgList',
            103: 'zjlList',
            10: 'costList'
          };
        } else if (this.Info.OnetimesOffPayback == 'true' && this.Info.TwotimesOffPayback == 'false') {
          var typeMap = {
            1: 'managerList',
            2: 'fuzerenList',
            3: 'designerList',
            4: 'zhianList',
            5: 'supporterList',
            6: 'partyAList',
            7: 'supervisorList',
            9: 'xieliList',
            101: 'zxList',
            102: 'fgList',
            10: 'costList'
          };
        } else if (this.Info.OnetimesOffPayback == 'false' && this.Info.TwotimesOffPayback == 'false') {
          var typeMap = {
            1: 'managerList',
            2: 'fuzerenList',
            3: 'designerList',
            4: 'zhianList',
            5: 'supporterList',
            6: 'partyAList',
            7: 'supervisorList',
            9: 'xieliList',
            101: 'zxList',
            10: 'costList'
          };
        }
        res.Data.proUsers.forEach(item => {
          const listName = typeMap[item.TypeId];
          if (listName) {
            this.memberObj[listName].push(item);
          }
        })


        for (let key in this.memberObj) {
          this.memberObj[key].splice(0, 1);
          if (this.memberObj[key].length == 0) {
            delete this.memberObj[key];
          }
        }
        for (let key in this.memberObj) {
          for (let i = 0; i < this.memberObj[key].length; i++) {
            this.$set(this.memberObj[key][i], 'isActive', false);
          }
        }
        // console.log(this.memberObj)
      }
    },
    back () {
      this.$router.go(-1)
    }
  },
  components: {
    detailHeader,
    dUpload
  },
  created () {
    this.init();
  },
}
</script>